





































































import { Component, Watch } from 'vue-property-decorator';
import Mixin from '@/mixin';
import { CoachClient, Paging, Table, TableHeader } from '@/store/models';
import VTable from '@/components/items/VTable.vue';
import VPaginationBar from '@/components/items/VPaginationBar.vue';
import VPopupResetPassword from '@/components/popup/VPopupResetPassword.vue';
import coachService from '@/services/common/coach.service';
import messageModule from '@/store/modules/common/message.module';

const PAGE_SIZE = 20;

@Component({
  name: 'CoachClients',
  components: {
    VTable,
    VPaginationBar,
    VPopupResetPassword
  }
})
export default class CoachClients extends Mixin {
  public search = this.$route.query.search_key || '';
  public clients: CoachClient[] = [];
  public paging: Paging | null = null;
  public loaded = false;
  public selectedClient: CoachClient | null = null;
  public showResetPassword = false;

  get coachName() {
    return (this.$route.query.coachName as string) || '';
  }

  public backToCoaches() {
    this.$router.push('/coaches');
  }

  get tableData() {
    return {
      headers: [
        {
          name: 'First Name',
          width: 'width--20',
          order: true,
          query: 'firstName'
        } as TableHeader,
        {
          name: 'Last Name',
          width: 'width--20',
          order: true,
          query: 'lastName'
        } as TableHeader,
        {
          name: 'Company Name',
          width: 'width--25',
          order: true,
          query: 'companyName'
        } as TableHeader,
        {
          name: 'Department',
          width: 'width--25',
          order: true,
          query: 'department'
        } as TableHeader
      ],
      property: {
        edit: false,
        delete: false,
        changePassword: true,
        index: true,
        func: () => '',
        overflow_y: true
      },
      values: { data: this.clients }
    } as Table;
  }

  public async doSearch(event: Event) {
    event.preventDefault();
    const queryParams = { ...this.$route.query };
    delete queryParams.offset;
    await this.$router.push({
      path: this.$route.path,
      query: {
        ...queryParams,
        search_key: this.search
      }
    });
  }

  public async selectedPage(page: number) {
    await this.$router.push({
      path: this.$route.path,
      query: {
        ...this.$route.query,
        offset: `${page}`
      }
    });
  }

  public doChangePassword(client: CoachClient) {
    messageModule.setMessage(null);
    this.selectedClient = client;
    this.showResetPassword = true;
  }

  public closeResetPassword() {
    messageModule.setMessage(null);
    this.showResetPassword = false;
    this.selectedClient = null;
  }

  get query() {
    return this.$route.query;
  }

  @Watch('query', { immediate: true, deep: false })
  public async loadClients() {
    // Keep the search box in sync with the route (covers back/forward).
    this.search = (this.$route.query.search_key as string) || '';

    // Always send limit so the endpoint stays in paging mode and returns
    // { clients, paging } rather than the legacy flat array. This screen is
    // reached from a coach, so coachId is expected; omit blank params so the
    // backend applies its defaults.
    const params: {
      limit: number;
      offset: number;
      search_key?: string;
      order_by?: string;
      coachId?: string;
    } = {
      limit: PAGE_SIZE,
      offset: Number(this.$route.query.offset) || 0
    };
    const searchKey = this.$route.query.search_key as string;
    const orderBy = this.$route.query.order_by as string;
    const coachId = this.$route.query.coachId as string;
    if (searchKey) params.search_key = searchKey;
    if (orderBy) params.order_by = orderBy;
    if (coachId) params.coachId = coachId;

    const data = await coachService.loadCoachClientsPaged(params);
    this.clients = data.clients;
    this.paging = data.paging;
    this.loaded = true;
  }
}
